<div class="w-full max-w-sm rounded-2xl bg-white p-5 shadow-xl sm:p-6">
  <div class="min-w-0">
    <h2 class="text-lg font-semibold text-slate-950">{{ title }}</h2>
    <p class="mt-2 text-sm leading-6 text-slate-600">{{ message }}</p>
  </div>

  <div class="mt-6 flex flex-col-reverse gap-2 sm:flex-row sm:justify-end">
    <lib-signal-button
      appearance="outline"
      [fullWidth]="false"
      (clicked)="onCancel()">
      {{ cancelLabel }}
    </lib-signal-button>
    <lib-signal-button [fullWidth]="false" (clicked)="onConfirm()">
      {{ confirmLabel }}
    </lib-signal-button>
  </div>
</div>
